<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="card">

                                                        <ul class="nav nav-tabs md-tabs" role="tablist">
                                                            <li class="nav-item">
                                                                <a class="nav-link active" @click="setStage('1')" data-toggle="tab" href="#stage1" role="tab" aria-expanded="false">Stage 1&nbsp;&nbsp;<span class="badge badge-primary">{{counts[1]}}</span></a>

                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item">
                                                                <a class="nav-link" @click="setStage('2')" data-toggle="tab" href="#stage2" role="tab" aria-expanded="false">Stage 2&nbsp;&nbsp;<span class="badge badge-primary">{{counts[2]}}</span></a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item">
                                                                <a class="nav-link" @click="setStage( '3')" data-toggle="tab" href="#stage3" role="tab" aria-expanded="false">Stage 3&nbsp;&nbsp;<span class="badge badge-primary">{{counts[3]}}</span></a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item">
                                                                <a class="nav-link" @click="setStage( '4')" data-toggle="tab" href="#stage4" role="tab" aria-expanded="false">Stage 4&nbsp;&nbsp;<span class="badge badge-primary">{{counts[4]}}</span></a>
                                                                <div class="slide"></div>
                                                            </li>
                                                        </ul>

                                                        <div class="tab-content card-block">
                                                            

                                                            <div class="tab-pane active" id="stage1" role="tabpanel" aria-expanded="false">
                                                                <h5 class="pb-3">Stage 1 Applicants</h5>

                                                                <div class="table-responsive">
                                                                    
                                                                    <div>
                                                                <input type="text" class="form-control" v-model="stage_1_opening_filter" @keyup.enter="search" placeholder="Search...">

                                                                    <select class=" mt-1 form-control" v-model="grades" @change="onChange($event)">
                                                                        <option value=""> All grades</option>
                                                                        <option value="First Class">First Class</option>
                                                                        <option value="Second Class Upper">Second Class Upper</option>
                                                                        <option value="Second Class Lower">Second Class Lower</option>
                                                                        <option value="Third Class">Third Class</option>
                                                                        <option value="Upper Credit">Upper Credit</option>
                                                                        <option value="Lower Credit">Lower Credit</option>
                                                                        
                                                                    </select>

                                                                    <div class="row align-items-center mt-1">
                                                                        <div class="col-offset-1 col-md-5">
                                                                            <label>Age</label>
                                                                            <VueSlider
                                                                                    :min="1"
                                                                                    :max="100"
                                                                                    ref="other1"
                                                                                    v-model="age"
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-5">
                                                                            <label>Experience</label>
                                                                            <VueSlider
                                                                                    :min="1"
                                                                                    :max="20"
                                                                                    ref="some1"
                                                                                    v-model="experience"
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-2 float-right">
                                                                            <label class="col-8">Has CV</label>
                                                                            <input class="col-1" v-model="has_cv" type="checkbox" value="1">
                                                                        </div>
                                                                    </div>
                                                                    <div class="row align-items-center mt-1">
                                                                         <div class="col-md-1 float-right">
                                                                            <button @click="change" class="btn btn-primary"> Apply </button>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                                    <!-- :filter-by="stage_1_opening_filter" -->
                                                                    <datatable :columns="stage_1_opening_columns" :data="stage_1_opening_rows"  name="stage_1_openings_table"></datatable>
                                                                    <div class="" style="text-align: center;">
<!--                                         
                                                                        <paginate
                                                                            :page-count="pageCount"
                                                                            :click-handler="onChangePage"
                                                                            :prev-text="'Prev'"
                                                                            :next-text="'Next'"
                                                                            :container-class="'pagination'"
                                                                            :page-class="'page-item'"
                                                                        ></paginate> -->
                                                                    </div>
                                                                    <!-- <div class="" style="text-align: center;">
                                                                        <datatable-pager v-model="stage_1_page" type="long" :per-page="stage_1_per_page" table="stage_1_openings_table"></datatable-pager>
                                                                    </div> -->
                                                                </div>
                                                                <h5 style="text-align: center;" v-show="stage_1_opening_rows.length < 1">No Stage 1 Applicants</h5>
                                                            </div>


                                                            <div class="tab-pane" id="stage2" role="tabpanel" aria-expanded="false">
                                                                <h5 class="pb-3">Stage 2 Applicants</h5>

                                                                <div class="table-responsive">
                                                                <div>
                                                                <input type="text" class="form-control" v-model="stage_2_opening_filter" @keyup.enter="search" placeholder="Search...">

                                                                    <select class=" mt-1 form-control" v-model="grades2" @change="onChange($event)">
                                                                        <option value=""> All grades</option>
                                                                        <option value="First Class">First Class</option>
                                                                        <option value="Second Class Upper">Second Class Upper</option>
                                                                        <option value="Second Class Lower">Second Class Lower</option>
                                                                        <option value="Third Class">Third Class</option>
                                                                        <option value="Upper Credit">Upper Credit</option>
                                                                        <option value="Lower Credit">Lower Credit</option>
                                                                    </select>

                                                                    <div class="row align-items-center mt-1 mb-1">
                                                                        <!-- <div class="col-md-5">
                                                                            <label>Age</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="10"
                                                                                    ref="other2"
                                                                                    :max="100"
                                                                                    width="200"
                                                                                    v-model="age2"
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-5">
                                                                            <label>Experience</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="1"
                                                                                    ref="some2"
                                                                                    :max="20"
                                                                                    width="200"
                                                                                    v-model="experience2"
                                                                            />
                                                                        </div>
                                                                        -->
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CV</label>
                                                                            <input class="col-1" v-model="has_cv2" type="checkbox" value="1">
                                                                        </div>
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CBT</label>
                                                                            <input class="col-1" v-model="has_cbt2" type="checkbox" value="1">
                                                                        </div>
                                                                        <div class="col-md-2 float-right">
                                                                            <button @click="change" class="btn btn-primary"> Apply </button>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                                    
                                                                    
                                                                    <!-- :filter-by="stage_2_opening_filter" -->
                                                                    <datatable :columns="stage_2_opening_columns" :data="stage_2_opening_rows"  name="stage_2_openings_table"></datatable>
                                                                    <!-- <div class="" style="text-align: center;">
                                                                        <datatable-pager v-model="stage_2_page" type="long" :per-page="stage_2_per_page" table="stage_2_openings_table"></datatable-pager>
                                                                    </div> -->
                                                                    <h5 style="text-align: center;" v-show="stage_2_opening_rows.length < 1">No Stage 2 Applicants</h5>
                                                                </div>
                                                            </div>


                                                            <div class="tab-pane" id="stage3" role="tabpanel" aria-expanded="true">
                                                                <h5 class="pb-3">Stage 3 Applicants</h5>

                                                                <div class="table-responsive">
                                                                <div>
                                                                <input type="text" class="form-control" v-model="stage_3_opening_filter" @keyup.enter="search" placeholder="Search...">

                                                                    <select class=" mt-1 form-control" v-model="grades3" @change="onChange($event)">
                                                                        <option value=""> All grades</option>
                                                                        <option value="First Class">First Class</option>
                                                                        <option value="Second Class Upper">Second Class Upper</option>
                                                                        <option value="Second Class Lower">Second Class Lower</option>
                                                                        <option value="Third Class">Third Class</option>
                                                                        <option value="Upper Credit">Upper Credit</option>
                                                                        <option value="Lower Credit">Lower Credit</option>
                                                                    </select>

                                                                    <div class="row align-items-center mt-1">
                                                                        <!-- <div class="col-md-5">
                                                                            <label>Age</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="1"
                                                                                    :max="100"
                                                                                    v-model="age3"
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-5">
                                                                            <label>Experience</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="1"
                                                                                    :max="20"
                                                                                    v-model="experience3"
                                                                            />
                                                                        </div>
                                                                        -->
                                                                        
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CV</label>
                                                                            <input class="col-1" v-model="has_cv3" type="checkbox" value="1">
                                                                        </div>
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CBT</label>
                                                                            <input class="col-1" v-model="has_cbt3" type="checkbox" value="1">
                                                                        </div>

                                                                        <div class="col-offset-10 col-md-2 float-right">
                                                                            <button @click="change" class="btn btn-primary"> Apply </button>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                                    
                                                                    <!-- :filter-by="stage_3_opening_filter" -->
                                                                    <datatable :columns="stage_3_opening_columns" :data="stage_3_opening_rows"  name="stage_3_openings_table"></datatable>

                                                                    <!-- <div class="" style="text-align: center;">
                                                                        <datatable-pager v-model="stage_3_page" type="long" :per-page="stage_3_per_page" table="stage_3_openings_table"></datatable-pager>
                                                                    </div> -->
                                                                    <h5 style="text-align: center;" v-show="stage_3_opening_rows.length < 1">No Stage 3 Applicants</h5>
                                                                </div>
                                                            </div>
                                                            <div class="tab-pane" id="stage4" role="tabpanel" aria-expanded="true">
                                                                <h5 class="pb-3">Stage 4 Applicants</h5>

                                                                <div class="table-responsive">
                                                                <div>
                                                                <input type="text" class="form-control" v-model="stage_4_opening_filter" @keyup.enter="search" placeholder="Search...">

                                                                    <select class=" mt-1 form-control" v-model="grades4" @change="onChange($event)">
                                                                        <option value=""> All grades</option>
                                                                        <option value="First Class">First Class</option>
                                                                        <option value="Second Class Upper">Second Class Upper</option>
                                                                        <option value="Second Class Lower">Second Class Lower</option>
                                                                        <option value="Third Class">Third Class</option>
                                                                        <option value="Upper Credit">Upper Credit</option>
                                                                        <option value="Lower Credit">Lower Credit</option>
                                                                    </select>

                                                                    <div class="row align-items-center mt-1">
                                                                        <!-- <div class="col-md-5">
                                                                            <label>Age</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="1"
                                                                                    :max="100"
                                                                                    v-model="age3"
                                                                            />
                                                                        </div>
                                                                        <div class="col-md-5">
                                                                            <label>Experience</label>
                                                                            <VueSimpleRangeSlider
                                                                                    :min="1"
                                                                                    :max="20"
                                                                                    v-model="experience3"
                                                                            />
                                                                        </div>
                                                                        -->
                                                                        
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CV</label>
                                                                            <input class="col-1" v-model="has_cv3" type="checkbox" value="1">
                                                                        </div>
                                                                        <div class="col-md-3 float-left">
                                                                            <label class="col-8">Has CBT</label>
                                                                            <input class="col-1" v-model="has_cbt3" type="checkbox" value="1">
                                                                        </div>

                                                                        <div class="col-offset-10 col-md-2 float-right">
                                                                            <button @click="change" class="btn btn-primary"> Apply </button>
                                                                        </div>
                                                                    </div>
                                                            </div>
                                                                    
                                                                    <!-- :filter-by="stage_3_opening_filter" -->
                                                                    <datatable :columns="stage_4_opening_columns" :data="stage_4_opening_rows"  name="stage_4_openings_table"></datatable>

                                                                    <!-- <div class="" style="text-align: center;">
                                                                        <datatable-pager v-model="stage_3_page" type="long" :per-page="stage_3_per_page" table="stage_3_openings_table"></datatable-pager>
                                                                    </div> -->
                                                                    <h5 style="text-align: center;" v-show="stage_4_opening_rows.length < 1">No Stage 4 Applicants</h5>
                                                                </div>
                                                            </div>
                                                            <div class="table-responsive" style="text-align: center;">
                                                            <paginate
                                                                            :page-count="pageCount"
                                                                            :click-handler="onChangePage"
                                                                            :prev-text="'Prev'"
                                                                            :next-text="'Next'"
                                                                            :container-class="'pagination'"
                                                                            :page-class="'page-item'"
                                                                        ></paginate>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active{
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {background-color: #00ff00;}
</style>
<script>
        
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    name: 'SingleOpeningApplicants',

    data(){
        return{
            grades: "",
            age: [20, 100],
            experience: [0, 10],
            grades2: "",
            age2: [20, 100],
            experience2: [0, 10],
            grades3: "",
            grades4: "",
            has_cv: "",
            has_cbt: "",
            has_cbt2: "",
            has_cbt3: "",
            has_cv2: "",
            has_cv3: "",
            age3: [20, 100],
            experience3: [0, 10],
            stage: 1,
            counts: [],
            stage_1_opening_filter: '',
            stage_1_page: 1,
            stage_1_per_page: 10,
            stage_1_opening_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Full Name', representedAs: (row)=> {
                    return row.firstname +' '+ row.lastname
                }, interpolate:true, sortable: true},
                {label: 'Phone Number', field: 'phonenumber', sortable: false},
                {label: 'Email', field: 'emailaddress', sortable: false},
                {label: 'Grades', field: 'grades', sortable: true},
                {label: 'Course', field: 'course', sortable: true},
                {label: 'Actions', representedAs: (row)=>{
                    if(row.is_viewed == true || row.is_viewed == 'true'){
                    return '<a href="application/'+row.id+'" style="color: #fff;" class="btn btn-danger btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                    }
                    return '<a onclick="turnRed('+row.id+')" id="application'+row.id+'" target="_blank" href="application/'+row.id+'" style="color: #fff;" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                }, interpolate: true, sortable: true}
            ],

            stage_1_opening_rows: [],

            stage_2_opening_filter: '',
            stage_2_page: 1,
            stage_2_per_page: 10,
            stage_2_opening_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Full Name', representedAs: (row)=> {
                    return row.firstname +' '+ row.lastname
                }, interpolate:true, sortable: true},
                {label: 'Phone Number', field: 'phonenumber', sortable: false},
                {label: 'Email', field: 'emailaddress', sortable: false},
                {label: 'Grades', field: 'grades', sortable: true},
                {label: 'Course', field: 'course', sortable: true},
                 {label: 'CBT Score', representedAs: (row)=> {
                    return this.scoreAnswers(row.cbt_answers)
                }, interpolate:true, sortable: true},
                {label: 'Actions', representedAs: (row)=>{
                    if(row.is_viewed == true || row.is_viewed == 'true'){
                        return '<a href="application/'+row.id+'" style="color: #fff;" class="btn btn-danger btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                    }
                    return '<a onclick="turnRed('+row.id+')" href="application/'+row.id+'" style="color: #fff;" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                }, interpolate: true, sortable: true}
            ],

            stage_2_opening_rows: [],

            stage_3_opening_filter: '',
            stage_3_page: 1,
            stage_3_per_page: 10,
            stage_3_opening_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Full Name', representedAs: (row)=> {
                    return row.firstname +' '+ row.lastname
                }, interpolate:true, sortable: true},
                {label: 'Phone Number', field: 'phonenumber', sortable: false},
                {label: 'Email', field: 'emailaddress', sortable: false},
                {label: 'Grades', field: 'grades', sortable: true},
                {label: 'Course', field: 'course', sortable: true},
                {label: 'CBT Score', representedAs: (row)=> {
                    return this.scoreAnswers(row.cbt_answers)
                }, interpolate:true, sortable: true},
                {label: 'Actions', representedAs: (row)=>{
                    if(row.is_viewed == true || row.is_viewed == 'true'){
                        return '<a href="application/'+row.id+'" style="color: #fff;" class="btn btn-danger btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                    }
                    return '<a onclick="turnRed('+row.id+')" href="application/'+row.id+'" style="color: #fff;" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                }, interpolate: true, sortable: true}
            ],

            stage_3_opening_rows: [],

            stage_4_opening_filter: '',
            stage_4_page: 1,
            stage_4_per_page: 10,
            stage_4_opening_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Full Name', representedAs: (row)=> {
                    return row.firstname +' '+ row.lastname
                }, interpolate:true, sortable: true},
                {label: 'Phone Number', field: 'phonenumber', sortable: false},
                {label: 'Email', field: 'emailaddress', sortable: false},
                {label: 'Grades', field: 'grades', sortable: true},
                {label: 'Course', field: 'course', sortable: true},
                {label: 'CBT Score', representedAs: (row)=> {
                    return this.scoreAnswers(row.cbt_answers)
                }, interpolate:true, sortable: true},
                {label: 'Actions', representedAs: (row)=>{
                    if(row.is_viewed == true || row.is_viewed == 'true'){
                        return '<a href="application/'+row.id+'" style="color: #fff;" class="btn btn-danger btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                    }
                    return '<a onclick="turnRed('+row.id+')" href="application/'+row.id+'" style="color: #fff;" class="btn btn-primary btn-mat btn-sm"><i class="icofont icofont-eye-alt"></i>View</a>&nbsp;&nbsp;<a href="javascript:void(0)"><i class="fa fa-star-o"></i></a>'
                }, interpolate: true, sortable: true}
            ],

            stage_4_opening_rows: [],

            id : 0       ,
            total: 0 ,
            
        }
        
    },

    components:{
        navbar1,
        navbar2,
        VueSlider
    },
    
    computed : {
        pageCount () {
                return Math.ceil(this.total / 20)
            },
    },

    mounted(){
        // document.querySelector('#test2').addEventListener('click', function() { alert("HOVER2") })
        
        // this.$refs.other2.width = 300.24

        document.title = 'Applications - Waje Smart Solutions Recruitment Portal'

        var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

        this.$swal.fire({
            title: "<h5></h5>", 
            html: loading_html,  
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false
        })

        //$('.theme-loader').hide()

        this.id =  this.$route.params.id

        this.getOpening(this.id)
    },
    methods: {
        calculateTotal (score_array, key){
				let total = 0
				let sa_length = score_array.length

				for (var i=0;i<sa_length;i++) {
                    // console.log(score_array[i][key])
					total = total + parseInt(score_array[i][key])
                }
                
                

				return total
			},
        scoreAnswers(question){
            

            if (question.length == 0){
                return ""
            }
				/*
					This functions, depending on the question type, compares the applicant answers with the question 
					answers and creates an array of the scores.
					AA = Applicant Answer
					QA = Question Answer
                */
                let scores = []

				let question_count = question.length

				//console.log(question[0])

				for (var i=0; i<question_count;i++) {
                    console.log(question[i])
					switch(question[i].question.questiontype){
						case 'oa':
						case 'sa':
							/*
								For these tests, we want to check if the AA vs QA values at the same
								indexes tally. If all values tally, the applicant
							*/
							if(JSON.stringify(question[i].applicant_answer).toLowerCase() == JSON.stringify(question[i].question.answers).toLowerCase()){
								scores[i] = {
									"score": parseInt(question[i].question.score)
								} 
							} else {
								scores[i] = {
									"score": 0
								}
							}
						break;
						case 'ma':
							/*
								For multiple answer questions, we want to check if items in the QA array are found in the AA
								array.
							
							
								Divide the score by the number of possible answers. For example, if the question score is
								10 and there are 2 correct answers, that means each input is worth 5 marks (10/2 = 5)
							*/
							var score = parseInt(question[i].question.score)

							//The correct question answer
							var qa = question[i].question.answers
							var qa_len = qa.length

							//Divide
							var each_input = score / qa_len

							//The applicant ansers
							var aa = question[i].applicant_answer
							var aa_len = aa.length

							

							//A variable to hold an increment in scores as we compare each array index.
							var temp_score = 0

							for(var j=0;j<qa_len;j++){
								//compare AA and QA arrays
								if(aa.includes(qa[j])){
									//Increase the temp score variable
									temp_score++
								}
							}

							scores[i] = {
								"score": temp_score
							}


						break;
						case 'st':
						case 'sj':
							/*
								For short text questions, we want to check if each index of AA tallies with 
								the answer in each index of the QA.
							
							
								Divide the score by the number of input fields. For example, if the question score is
								20 and there are 2 blank inputs, that means each input is worth 10 marks (20/2 = 10)
							*/
							//The score of the question
							var score = parseInt(question[i].question.score)
							//Number of inputs
							var input_count = parseInt(question[i].question.inputs)
							//Divide
							var each_input = score / input_count

							//The applicant ansers
							var aa = question[i].applicant_answer
							var aa_len = aa.length

							//The correct question answer
							var qa = question[i].question.answers
							var qa_len = qa.length

							//A variable to hold an increment in scores as we compare each array index.
							var temp_score = 0

							//If we are going to loop through 2 different arrays, using the same increment, we should
							//check that they are the same length so we don't run into any errors (index not found type of error)
							if(qa_len == aa_len){
								for(var j=0;j<aa_len;j++){
									//compare AA and QA arrays
									if(aa[j] == qa[j]){
										//Increase the temp score variable
										temp_score++
									}
								}

								scores[i] = {
									"score": temp_score
								}

							} else {
								scores[i] = {
									"score": 0
								}
							}
								
						break;
						default:
							scores[i] = {
								"score": 0
							}
						break;
					}
				}

				let applicant_total_score = this.calculateTotal(scores, "score")
				let question_total_score = question.map(x => Number(x.question.score)).reduce((prev, curr) => prev + curr) //this.calculateTotal(question, "score")
                console.log(question_total_score)
                return parseFloat((applicant_total_score * 100) / question_total_score).toFixed(2)	+ '%'	
			},
        
        search() {
            // if(val.length > 2) {
                this.getOpening(this.id , this.stage, 1)
            // }
        },
        onChange() {
            // this.getOpening(this.id , this.stage, 1)
        },

        change() {
            this.getOpening(this.id , this.stage, 1)
        },

        getNewgrades() {
            // this.getOpening(this.id , this.stage, 1)
        },
        setStage(stage) {
            this.stage = stage
           
            this.getOpening(this.id, this.stage, 1)
        },
        onChangePage(page) {
            // update page of items
            // console.log(page)
            
                this.getOpening(this.id , this.stage, page)
            },
        getOpening(id, stage=1, page=1){

            var get_openings_request = {
                what: 'getApplicants',
                params: {
                    "joblisting_id": id,
                    "stage": stage,
                    "page": page,
                    "search": "",
                    "grades": "",
                    "age" : '0,100',
                    "experience" : '0,10',
                    "has_cv" : "",
                    "has_cbt" : "",
                }
            }

            if(stage == '1'){
                get_openings_request.params.search = this.stage_1_opening_filter
                get_openings_request.params.grades = this.grades
                get_openings_request.params.age = this.age
                get_openings_request.params.experience = this.experience
                get_openings_request.params.has_cv = this.has_cv
            } else if(stage == '2'){
                get_openings_request.params.search = this.stage_2_opening_filter
                get_openings_request.params.grades = this.grades2
                get_openings_request.params.age = this.age2
                get_openings_request.params.experience = this.experience2
                get_openings_request.params.has_cv = this.has_cv2
                get_openings_request.params.has_cbt = this.has_cbt2
            } else if(stage == '3'){
                get_openings_request.params.search = this.stage_3_opening_filter
                get_openings_request.params.grades = this.grades3
                get_openings_request.params.age = this.age3
                get_openings_request.params.experience = this.experience3
                get_openings_request.params.has_cv = this.has_cv3
                get_openings_request.params.has_cbt = this.has_cbt3
            } else {
                get_openings_request.params.search = this.stage_4_opening_filter
                get_openings_request.params.grades = this.grades4
                get_openings_request.params.age = this.age3
                get_openings_request.params.experience = this.experience3
                get_openings_request.params.has_cv = this.has_cv3
                get_openings_request.params.has_cbt = this.has_cbt3
            }

            this.$socket.makeGetRequest(get_openings_request)
                .then((response)=>{
                    if(response.type == 'getApplicants'){
                        // var all_applicants = response.data
                        let all_applicants = response.data.data
                        this.counts = response.counts
                        console.log(this.counts);
                            this.total = response.data.total;
                        this.$swal.close()
                        // for(var i=0;i<all_applicants.length;i++){
                            if(stage == '1'){
                                this.stage_2_opening_rows = []
                                this.stage_3_opening_rows = []
                                this.stage_1_opening_rows = all_applicants
                            } else if(stage == '2'){
                                this.stage_1_opening_rows = []
                                this.stage_3_opening_rows = []
                                this.stage_2_opening_rows = all_applicants
                            } else if(stage == '3'){
                                this.stage_2_opening_rows = []
                                this.stage_1_opening_rows = []
                                this.stage_3_opening_rows = all_applicants
                            } else {
                                this.stage_2_opening_rows = []
                                this.stage_1_opening_rows = []
                                this.stage_3_opening_rows = []
                                this.stage_4_opening_rows = all_applicants
                            }
                        // }
                        //this.opening_rows = response.data
                    }
                })
                .catch((e)=>{
                    console.log(e)
                })
        }
    },
}
</script>
